// Make dropdown parent links clickable on desktop (hover devices)
(() => {
  const isDesktop = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function handler(e) {
    if (!isDesktop()) return;

    const li = e.target.closest("li.has-children");
    if (!li) return;

    // Allow normal clicks inside submenu
    if (e.target.closest(".submenu")) return;

    // Your parent link
    const parentLink = li.querySelector("a.cms-item-title[href]");
    if (!parentLink) return;

    // If user clicked another link, let it work
    const clickedLink = e.target.closest("a[href]");
    if (clickedLink && clickedLink !== parentLink) return;

    // Override theme dropdown click logic and navigate
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    window.location.assign(parentLink.href);
  }

  // pointerdown catches before click/preventDefault handlers
  document.addEventListener("pointerdown", handler, true);
})();
